module.exports = __webpack_public_path__ + "static/media/videoEditor-2.62db7719.webp";